import React from "react";
import { Container, Typography, Box, Grid, Divider, styled } from "@mui/material";
import aboutcls from "../../images/aboutcls.jpg";

// Styled Components
const SectionTitle = styled(Typography)({
  fontFamily: "Poppins, sans-serif",
  fontWeight: "bold",
  fontSize: "2.5rem",
  color: "#1976d2",
  textAlign: "center",
  marginBottom: "20px",
});

const Subtitle = styled(Typography)({
  fontFamily: "Poppins, sans-serif",
  fontWeight: "600",
  fontSize: "1.5rem",
  color: "#333",
  textAlign: "center",
  marginTop:'10px',
  marginBottom: "10px",
});

const Description = styled(Typography)({
  fontFamily: "Poppins, sans-serif",
  fontWeight: "400",
  fontSize: "1rem",
  color: "#555",
  lineHeight: "1.8",
  textAlign: "left",
});

const HighlightText = styled(Typography)({
  fontFamily: "Poppins, sans-serif",
  fontWeight: "bold",
    fontSize: "2rem",
  color: "#1976d2",
  textAlign: "center",
  margin: "20px 5px",
  
});

const SectionContainer = styled(Box)({
  padding: "40px 20px",
  textAlign: "center",
});

const AboutClasses = () => {
  return (
    <Container maxWidth="lg" sx={{ marginTop: 4, marginBottom: 4 }}>
      {/* About Yoga and Meditation Classes Section */}
      <SectionContainer>
        <SectionTitle variant="h2">About Yoga and Meditation Classes</SectionTitle>
        <Subtitle variant="h4">Online and In-person</Subtitle>
        <Grid container spacing={4} sx={{ marginTop: 2 }}>
          <Grid item xs={12} md={6}>
            <Description variant="body1">
              <strong>Group Classes:</strong> Join our community-driven group classes designed to foster connection and collective energy.
            </Description>
          </Grid>
          <Grid item xs={12} md={6}>
            <Description variant="body1">
              <strong>Private Individual Classes:</strong> Personalized sessions tailored to your unique needs and goals.
            </Description>
          </Grid>
          <Grid item xs={12} md={6}>
            <Description variant="body1">
              <strong>Therapeutic Yoga Classes:</strong> Focused on healing and recovery, these classes address specific health concerns.
            </Description>
          </Grid>
          <Grid item xs={12} md={6}>
            <Description variant="body1">
              <strong>Pregnancy Yoga:</strong> Safe and supportive yoga practices for expecting mothers.
            </Description>
          </Grid>
          <Grid item xs={12} md={6}>
            <Description variant="body1">
              <strong>Kids Yoga and Meditation Classes:</strong> Fun and engaging classes to introduce children to mindfulness and movement.
            </Description>
          </Grid>
        </Grid>
      </SectionContainer>

      <Divider sx={{ margin: "40px 0", borderColor: "#ddd" }} />

      {/* Dive into the World of Health & Fitness Section */}
      <SectionContainer>
  <Grid container spacing={4} alignItems="center">
    {/* Left Column: Text Content */}
    <Grid item xs={12} md={6}>
      <HighlightText variant="h">DIVE INTO THE WORLD OF HEALTH & FITNESS</HighlightText>
      <Subtitle variant="h4">YOGA – THE GREATEST MEDICINE</Subtitle>
      <Description variant="body1" sx={{ maxWidth: "800px", margin: "auto", textAlign: "left" }}>
        Yoga serves as a tool for overcoming many health issues. It is more powerful when done with Prana yoga. Several wonders are achieved with this yogic method.
      </Description>
    </Grid>

    {/* Right Column: Image */}
    <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
      <img
        src={aboutcls} // Replace with your image URL
        alt="Yoga and Fitness"
        style={{ width: "70%", maxWidth: "500px", borderRadius: "8px" ,height:"500px"}}
      />
    </Grid>
  </Grid>
</SectionContainer>

      <Divider sx={{ margin: "40px 0", borderColor: "#ddd" }} />

      {/* Private Meditation Classes Section */}
      <SectionContainer>
        <SectionTitle variant="h2">Private Meditation Classes</SectionTitle>
        <Description variant="body1" sx={{ maxWidth: "800px", margin: "auto" }}>
          Meditation has been proven by clinical research to help relieve pain and anxiety, aid in smoking cessation, weight loss, and improve sleep.
        </Description>
        <Grid container spacing={4} sx={{ marginTop: 4 }}>
          <Grid item xs={12} md={4}>
            <Subtitle variant="h5">Mindfulness Meditation</Subtitle>
            <Description variant="body1">
              The process of being fully present with your awareness, cultivating a sense of calm and focus.
            </Description>
          </Grid>
          <Grid item xs={12} md={4}>
            <Subtitle variant="h5">Transcendental Meditation</Subtitle>
            <Description variant="body1">
              A simple, natural technique practiced for 20 minutes twice daily while sitting comfortably with closed eyes.
            </Description>
          </Grid>
          <Grid item xs={12} md={4}>
            <Subtitle variant="h5">Guided Meditation</Subtitle>
            <Description variant="body1">
              Includes self-healing techniques to promote relaxation, reduce stress, and enhance overall well-being.
            </Description>
          </Grid>
        </Grid>
      </SectionContainer>



    </Container>
  );
};

export default AboutClasses;